import RecallOptionsContainer from './RecallOptionsContainer';

export default RecallOptionsContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/RecallOptions/index.js